import Modal from 'react-modal'
import { Container, ModalBody, ModalHeader } from './styles'
import { MdClose } from 'react-icons/md'
import { FaCheckCircle } from 'react-icons/fa'
import { Box, Flex } from '@chakra-ui/react'
import { iCompetencia, iModalPadrao, iQuestao } from '../../../../interfaces'

interface IModalProps extends iModalPadrao {
  Competencia: iCompetencia
  Questoes: iQuestao[]
}

export const ModalPreVizualizarQuestao: React.FC<IModalProps> = ({ OnCloseModal, isOpen, Questoes, Competencia }) => {
  if (!isOpen) {
    return null
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={OnCloseModal}
      overlayClassName='react-modal-overlay'
      className={'react-modal-content-scroll'}
    >
      <Container>
        <ModalHeader>
          <Flex alignItems={'center'}>
            <img src={Competencia.icone} />
            <h4>{Competencia.nome}</h4>
          </Flex>
          <Box style={{ color: 'var(--Red)' }}>
            <MdClose
              onClick={() => OnCloseModal()}
              cursor={'pointer'}
              size={18}
            />
          </Box>
        </ModalHeader>

        <ModalBody>
          {
            Questoes.map((e: iQuestao, i) => {
              return (
                <div key={i}>
                  <FaCheckCircle color='var(--Azul)' size={18} />
                  <span>{e.enunciado}</span>
                </div>
              )
            })
          }
        </ModalBody>
      </Container>
    </Modal>
  )
}
